import { mapOpsiumUserShortFromDTO } from '@/modules/team/mappers/opsium-user-short.mapper';

import {
  TimeOffAttachmentResponse,
  TimeOffRequestDetailsResponse,
} from '../types/dto/time-off-request-details.dto';
import { DayPortion } from '../types/time-off-request';
import { TimeOffRequestAttachment, TimeOffRequestDetails } from '../types/time-off-request-details';
import { mapApprover, mapTimeOffType } from './time-off-request.mapper';

const mapAttachment = (attachment: TimeOffAttachmentResponse): TimeOffRequestAttachment => ({
  id: attachment.id,
  fileName: attachment.fileName,
  url: attachment.url,
});

export const mapTimeOffRequestDetailsFromDTO = (
  response: TimeOffRequestDetailsResponse
): TimeOffRequestDetails => ({
  id: response.id,
  type: mapTimeOffType(response.type),
  status: response.status,
  startDate: response.startDate,
  endDate: response.endDate,
  totalDays: response.totalDays,
  days: response.days.map(day => ({
    date: day.date,
    partOfDay: day.partOfDay,
    portion: day.portion as unknown as DayPortion,
    minutes: day.minutes,
  })),
  partOfDay: response.partOfDay,
  approvers: response.approvers.map(mapApprover),
  requestedBy: mapOpsiumUserShortFromDTO(response.requester.user),
  requestedAt: response.requestedAt,
  approvedAt: response.approvedAt,
  timeCategory: response.timeCategory,
  description: response.description ?? null,
  allowedActions: response.allowedActions,
  attachments: response.attachments.map(mapAttachment),
});
